export const questions = [
    {
        id: 9,
        q: "I am getting suicidal thoughts.",
        a: "Do not worry, help is here. You can write to us helpline@projectsakura.com and get a free consultation session. We are here for you.",
        img: "https://pixabay.com/get/g7c28ef1244e51d2fdd74d9c57c973163b4269b440346d8759f2e07f58709db9a1b4acd70ecd49c000d45d95c29b28760_640.jpg"
    },
    {
        id: 14,
        q: "What is Depression?",
        a: "A mental health disorder characterised by persistently depressed mood or loss of interest in activities, causing significant impairment in daily life. Possible causes include a combination of biological, psychological and social sources of distress." ,
        img: "https://pixabay.com/get/g64075f89fa3b32d81d1db9e71430dc67f4e06ac2daa4e8e7366345308e3a73b8e897887086a089f8e15bf71c8c7d593f_640.jpg"
    },
    {
        id: 15,
        q: "What is Schizophrenia?",
        a: "People with schizophrenia can have trouble distinguishing reality from fantasy, expressing and managing normal emotions and making decisions. Thought processes may also be disorganized, motivation to engage in life’s activities may be blunted and a belief that people are plotting against them." ,
        img: "https://pixabay.com/get/g8634a177247ac5c2c26a8e927e7d8a37843db02eff18a0bd4ac666d329fa2eae319d3bbf24255195dae0b8b88575e40c_640.jpg"
    },
    {
        id: 1,
        q: "What’s the difference between anxiety & generalized anxiety disorder (GAD)?",
        a: "Anxiety is a normal emotional response that we all feel from time to time. It’s your body’s way of preparing itself for an emergency. But if you suffer from GAD, you can experience constant, excessive and unrealistic worry for months at a time. Issues like money, health, family or work can trigger the disorder. It may seem things are beyond control." ,
        img: "https://pixabay.com/get/gb6e7dde5154a47721b55e8c65edf1a5ec27278e3742ea851d3febab00dcc80097d641cd31b1ceac4700a7da3cef62e6b_640.jpg"
    },
    {
        id: 2,
        q: "Does generalized anxiety disorder (GAD) qualify as a disability?",
        a:"People with GAD may qualify for Social Security disability benefits if their symptoms are well documented and are severely debilitating. A proper diagnosis is a crucial first step. Your Mercy doctor must submit medical evidence of your diagnosis, including psychological testing and documentation of your symptoms.",
        img: "https://pixabay.com/get/gb6e7dde5154a47721b55e8c65edf1a5ec27278e3742ea851d3febab00dcc80097d641cd31b1ceac4700a7da3cef62e6b_640.jpg"
    },
    {
        id: 3,
        q: "How long can a panic attack last?",
        a: "When a panic attack begins, the intense fear and discomfort typically reach a peak within 10 minutes. Panic attacks can last up to 30 minutes and seldom continue longer than an hour.",
        img: "https://pixabay.com/get/g30c15263e379248b074b5730321100a0f7647808a607b59267feddeb00be6b1adee317084dfed22d39c3e434494a0306_640.jpg"
    },
    {
        id: 4,
        q: "Are sleeping disorders and anxiety/overthinking, signs of depression?",
        a: "Yes, they can be. Depression-related ruminations often result in insomnia and anxiety. But it also important to realize that there are many other causes for anxiety (e.g. Post-Traumatic Stress Disorder, phobias) and sleep problems (e.g. sleep apnea) besides depression. Treating depression can sometimes relieve all these associated symptoms.",
        img: "https://pixabay.com/images/download/chair-5553870_640.jpg"
    },
    {
        id: 5,
        q: "What are the symptoms of depression?",
        a: "The two core signs of depression have not changed much since Lincoln’s days and include sadness (crying spells, emptiness, loss of hope) and loss of interest in your usual hobbies or activities. Supporting features include guilt, lack of energy, sleeping too much or too little, weight changes, poor concentration, thoughts of death, and change in activity levels.",
        img: "https://pixabay.com/get/g64075f89fa3b32d81d1db9e71430dc67f4e06ac2daa4e8e7366345308e3a73b8e897887086a089f8e15bf71c8c7d593f_640.jpg"
    },
    {
        id: 6,
        q: "What is insomnia?",
        a: "Persistent problems falling and staying asleep. Most cases of insomnia are related to poor sleeping habits, depression, anxiety, lack of exercise, chronic illness or certain medication.",
        img: "https://pixabay.com/get/gaad34bbeba5e3f4ac4c4936d8410817c177adc28c782a2048da1f5dd684b8be68a8e36f7867045b5274efebc37a5d97f_640.jpg"
    },
    {
        id: 7,
        q: "What is bipolar disorder?",
        a: "A disorder associated with episodes of mood swings ranging from depressive lows to manic highs. The exact cause of bipolar disorder isn’t known, but a combination of genetics, environment and altered brain structure and chemistry may play a role.",
        img: "https://pixabay.com/get/gff312417b6c0284f9c2bbde5e3869e56119a1891a015d80cfe329bc19f9b5c436121695b87aa533c87aa6092f65bb8b7_640.jpg"
    },
    {
        id: 8,
        q: "What is PTSD?",
        a: "Post-traumatic stress disorder (PTSD) is a mental health condition that's triggered by a terrifying event — either experiencing it or witnessing it. Symptoms may include flashbacks, nightmares and severe anxiety, as well as uncontrollable thoughts about the event.",
        img: "https://pixabay.com/get/g7ddce01c72d87a6c3ca4ecb17e510231429a06388e677a97a3a3bc7d2ce8e01e37e53bc816a04fc10752da29978b9e32_640.jpg"
    },
    {
        id: 10,
        q: "What is hypersomnia?",
        a: "Excessive sleepiness can have causes that aren't due to underlying disease. Examples include lack of sleep, jet lag, extreme exertion, eating a large meal, pregnancy, alcohol or use of marijuana.",
        img: "https://pixabay.com/get/gff312417b6c0284f9c2bbde5e3869e56119a1891a015d80cfe329bc19f9b5c436121695b87aa533c87aa6092f65bb8b7_640.jpg"
    },
    {
        id: 11,
        q: "What are the symptoms of ADHD?",
        a: "The two core signs of depression have not changed much since Lincoln’s days and include sadness (crying spells, emptiness, loss of hope) and loss of interest in your usual hobbies or activities. Supporting features include guilt, lack of energy, sleeping too much or too little, weight changes, poor concentration, thoughts of death, and change in activity levels.",
        img: "https://pixabay.com/get/g9f978809baa1919ba716171b258c7981ff47e568153f0ab2f672f499cae9a74bf5192c3864308a293bf35fa2813dedb4_640.jpg"
    },
    {
        id: 12,
        q: "What is Autism?",
        a: "The two core signs of depression have not changed much since Lincoln’s days and include sadness (crying spells, emptiness, loss of hope) and loss of interest in your usual hobbies or activities. Supporting features include guilt, lack of energy, sleeping too much or too little, weight changes, poor concentration, thoughts of death, and change in activity levels.",
        img: "https://pixabay.com/get/gc21ad5b9d87ecd95a08d579ec6cefd055bf68f19aff9a384c1ab654ebf9be343aee8700b9f86fea52c26f240453a363f_640.jpg"
    },
    {
        id: 13,
        q: "What are the symptoms of Dyslexia?",
        a: "The two core signs of depression have not changed much since Lincoln’s days and include sadness (crying spells, emptiness, loss of hope) and loss of interest in your usual hobbies or activities. Supporting features include guilt, lack of energy, sleeping too much or too little, weight changes, poor concentration, thoughts of death, and change in activity levels.",
        img: "https://pixabay.com/get/gff312417b6c0284f9c2bbde5e3869e56119a1891a015d80cfe329bc19f9b5c436121695b87aa533c87aa6092f65bb8b7_640.jpg"
    }
]

export const doctorData = [
    {
        id: 1,
        name: "Dr. Harleen Quinzel, Psychotherapist",
        experience: 10,
        about: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed nunc justo, varius vitae sapien quis, consectetur pharetra massa. Vestibulum iaculis hendrerit ipsum, et aliquet urna fermentum at.",
        Why: ["Consults on Wed, Thu, Fri", "Specializes in Psychotherapy", "5 Years Experience in Rehab Facility"],
        Why2: ["Has Researched on ADHD, Depression", "Associated with rehabs for drug addiction"],
        img: 1
    },
    {
        id: 2,
        name: "Dr. Martin Schruello, Psychologist",
        experience: 12,
        about: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed nunc justo, varius vitae sapien quis, consectetur pharetra massa. Vestibulum iaculis hendrerit ipsum, et aliquet urna fermentum at.",
        Why: ["Consults on Wed, Thu, Fri", "Specializes in Psychotherapy", "5 Years Experience in Rehab Facility"],
        Why2: ["Has Researched on ADHD, Depression", "Associated with rehabs for drug addiction"],
        img: 0
    },
    {
        id: 3,
        name: "Dr. Vincent Kemp, Psychiatrist",
        experience: 15,
        about: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed nunc justo, varius vitae sapien quis, consectetur pharetra massa. Vestibulum iaculis hendrerit ipsum, et aliquet urna fermentum at.",
        Why: ["Consults on Wed, Thu, Fri", "Specializes in Psychotherapy", "5 Years Experience in Rehab Facility"],
        Why2: ["Has Researched on ADHD, Depression", "Associated with rehabs for drug addiction"],
        img: 0
    },
    {
        id: 4,
        name: "Dr. Dan Daniel, Health Counsellor",
        experience: 7,
        about: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed nunc justo, varius vitae sapien quis, consectetur pharetra massa. Vestibulum iaculis hendrerit ipsum, et aliquet urna fermentum at.",
        Why: ["Consults on Mon, Fri", "Specializes in Psychotherapy", "5 Years Experience in Rehab Facility"],
        Why2: ["Has Researched on ADHD, Depression", "Associated with rehabs for drug addiction"],
        img: 0

    },
    {
        id: 5,
        name: "Dr. Mona Sax, Clinical Pyschologist",
        experience: 5,
        about: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed nunc justo, varius vitae sapien quis, consectetur pharetra massa. Vestibulum iaculis hendrerit ipsum, et aliquet urna fermentum at.",
        Why: ["Consults on Wed, Fri", "Specializes in PTSD", "2 Years Experience in Police Medical Department"],
        Why2: ["Has Researched on Trauma Relief, Depression, PTSD", "Associated with rehabs for alcohol addiction"],
        img: 1
    },
    {
        id: 6,
        name: "Dr. Selina Kyle, Neuropsychologist",
        experience: 9,
        about: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed nunc justo, varius vitae sapien quis, consectetur pharetra massa. Vestibulum iaculis hendrerit ipsum, et aliquet urna fermentum at.",
        Why: ["Consults on Mon, Tue, Wed", "Specializes in Trauma Relief", "4 Year Experience in the Military"],
        Why2: ["Has Researched on PTSD", "Associated with rehabs for PTSD"],
        img: 1
    },
    {
        id: 7,
        name: "Dr. Elizbeth Gordon, Psychotherapist",
        experience: 9,
        about: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed nunc justo, varius vitae sapien quis, consectetur pharetra massa. Vestibulum iaculis hendrerit ipsum, et aliquet urna fermentum at.",
        Why: ["Consults on Mon, Thu, Fri", "Specializes in Psychiatry", "7 Years Experience in Rehab Facility"],
        Why2: ["Has Researched on Bipolar Disorders", "Associated with rehabs for alcohol addiction"],
        img: 1
    },
    {
        id: 8,
        name: "Dr. Arthur Fleck, Psychiatrist",
        experience: 20,
        about: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed nunc justo, varius vitae sapien quis, consectetur pharetra massa. Vestibulum iaculis hendrerit ipsum, et aliquet urna fermentum at.",
        Why: ["Consults on Wed only", "Specializes in Hypnotism", "Specialises in Depression treatment"],
        Why2: ["Has Researched on Insomnia & Depression", "Associated with rehabs for PTSD"],
        img: 0
    } 
]
